<template>
  <BreadCrumbDetail :PageTitle="t('breadCrumb.users')" />
  <UsersContentByCompany />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import BreadCrumbDetail from "../../components/Common/BreadCrumbDetail.vue";
import UsersContentByCompany from "../../components/CRM/Leads/UsersContentByCompany.vue";


export default defineComponent({
  name: "UsersByCompanyPage",
  components: {
    BreadCrumbDetail,
    UsersContentByCompany,
  },
  setup() {
      const { t } = useI18n();
      return {
      t,
    };
    }
});
</script>